import { ApplicationReference } from '@newday/plum-types';

export const getMockApplicationReference = (): ApplicationReference => ({
  reference: '036101167',
});
